import { Component, Inject, LOCALE_ID } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from '../../../admin/services/admin.service';
import { NgForm } from '@angular/forms';
import { InventoryParameters } from '../../models/Inventory.interface';

@Component({
  selector: 'app-inventory-parameter',
  templateUrl: './inventory-parameter.dialog.html',
  styleUrl: './inventory-parameter.dialog.scss'
})
export class InventoryParameterDialog {

  parms: InventoryParameters;
  selectedItemTypes: number[] = [];

  constructor(@Inject(LOCALE_ID) locale: string,
    public dialogRef: MatDialogRef<InventoryParameterDialog>, private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.parms = data as InventoryParameters;
  };

  runReport(form: NgForm): void {
    if (form.valid) {
      this.parms.itemTypeId = this.selectedItemTypes;
      this.dialogRef.close(this.parms);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
